// extracted by mini-css-extract-plugin
var _1 = "StatisticSummaryTab-moduletable__j4E9U";
var _2 = "StatisticSummaryTab-moduletbody__KronM";
export { _1 as "table", _2 as "tbody" }
